import { Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export function TravelRequiredFieldsNote() {
  const { t } = useTranslation();
  const [before, after] = t('travel.requests.form.requiredNote').split('*');

  return (
    <Text
      size="sm"
      c="dimmed"
    >
      {before}
      {after != null && (
        <Text
          span
          inherit
          c="var(--mantine-color-error)"
        >
          *
        </Text>
      )}
      {after}
    </Text>
  );
}
